import __vue_component__ from '../../Form/TextField.vue.js';
import __vue_component__$1 from '../../Popper/Popper.vue.js';
import __vue_component__$3 from '../Icons.vue.js';
import { EventBus } from '../../event-bus.js';
import __vue_component__$2 from './SelectMenu.vue.js';

//
const INPUT_WIDTH = '5px';
var script = {
  components: {
    TextField: __vue_component__,
    Popper: __vue_component__$1,
    SelectMenu: __vue_component__$2,
    Icons: __vue_component__$3
  },
  props: {
    value: {
      type: [Object, Array],
      default: () => ({})
    },
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: 'Type to search...'
    },
    searchPromptText: {
      type: String,
      default: 'Type to search...'
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isFetching: {
      type: Boolean,
      default: false
    },
    isFocused: {
      type: Boolean,
      default: false
    },
    isInvalid: {
      type: Boolean,
      default: false
    },
    async: {
      type: Boolean,
      default: false
    },
    boundariesElement: {
      type: String,
      default: 'viewport'
    },
    noOptionsMessage: {
      type: String,
      default: 'No options'
    },
    isClearable: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      isOpen: false,
      search: '',
      focused: false,
      currentSuggestionId: undefined,
      currentWidth: INPUT_WIDTH,
      isDirty: false,
      selectWidth: 'auto',
      visibleNodesIds: [],
      index: undefined,
      ancestors: []
    };
  },

  computed: {
    selected() {
      return this.value;
    },

    nodes() {
      return this.getChildNodes(this.options);
    },

    input() {
      if (this.search) {
        return '';
      }

      return this.selected.label || this.placeholder;
    },

    isAnyOptionSelected() {
      return !!this.selected.id;
    }

  },
  watch: {
    isFocused: {
      handler(isFocused) {
        if (isFocused) {
          this.$nextTick(() => this.$refs.input.focus());
        }
      },

      immediate: true
    },

    search() {
      if (!this.search) this.currentWidth = INPUT_WIDTH;
      if (this.async && this.search) this.isDirty = true;
      this.$emit('search-change', this.search);
      this.updateVisibleNodes();
    },

    isOpen(open) {
      if (!open) {
        this.currentSuggestionId = undefined;
        this.$emit('close');
      } else {
        const {
          width
        } = this.$refs.target.getBoundingClientRect();
        this.selectWidth = `${width}px`;
        this.$emit('open');
        this.updateVisibleNodes();
      }
    },

    isFetching(isFetching) {
      if (!isFetching) {
        this.isDirty = false;
      }
    },

    suggestions() {
      this.$nextTick(() => this.updatePopperPosition());
    },

    index(index) {
      this.currentSuggestionId = this.visibleNodesIds[index];
    }

  },
  methods: {
    onFocus(e) {
      if (this.isLoading) return;
      this.focused = true;

      if (!this.$refs.target.contains(e.relatedTarget)) {
        this.isOpen = true;
      }

      this.$emit('focus', e);
    },

    onBlur(e) {
      if (!this.$refs.target.contains(e.relatedTarget)) {
        this.search = '';
        this.closeOptions();
        this.$emit('blur', e);
      }
    },

    click() {
      this.isOpen = !this.isOpen;
      this.$refs.input.focus();
    },

    onEsc() {
      this.isOpen = false;
      this.$emit('cancel');
    },

    closeOptions() {
      this.isOpen = false;
      this.focused = false;
    },

    onClear() {
      this.$emit('input', undefined);
      this.isOpen = false;
      this.$nextTick(() => this.$refs.input.focus());
    },

    onOptionSelected(option, ancestors) {
      this.ancestors = ancestors;
      this.search = '';
      this.focused = true;
      this.$refs.input.focus();
      this.isOpen = false;
      this.$emit('input', option);
    },

    onInput({
      target
    }) {
      this.search = target.value;
      this.isOpen = true;
      this.resize();
      this.updatePopperPosition();
    },

    removeOption() {
      if (!this.search && this.selected) {
        this.$emit('input', undefined);
      }
    },

    onNextSuggestion() {
      if (!this.isOpen) this.isOpen = true;

      if (this.currentSuggestionId === undefined) {
        this.index = 0;
      } else {
        this.index = this.index + 1;

        if (this.index > this.visibleNodesIds.length - 1) {
          this.index = 0;
        }
      }
    },

    onPreviousSuggestion() {
      if (!this.isOpen) this.isOpen = true;

      if (this.currentSuggestionId === undefined) {
        this.index = this.visibleNodesIds.length - 1;
      } else {
        this.index = this.index - 1;

        if (this.index < 0) {
          this.index = this.visibleNodesIds.length - 1;
        }
      }
    },

    onMouseOverSuggestion(id) {
      this.currentSuggestionId = id;
    },

    onSuggestionSelected(e) {
      // if current index is undefined, means we don't want to select any value, just submit
      if (this.currentSuggestionId === undefined) {
        this.$emit('confirm', e);
        return;
      }

      e.preventDefault();
      EventBus.$emit('remote-select');
      this.currentSuggestionId = undefined;
      this.$nextTick(() => {
        this.$refs.input.focus();
      });
    },

    resize() {
      this.$nextTick(() => {
        if (this.$refs.input) {
          this.currentWidth = `${this.$refs.input.scrollWidth}px`;
        }
      });
    },

    updatePopperPosition() {
      if (this.$refs.menu) {
        this.$refs.menu.update();
      }
    },

    getChildNodes(children = []) {
      return children.reduce((nodes, node) => {
        if (node.children) {
          return [...nodes, node, ...this.getChildNodes(node.children)];
        }

        return [...nodes, node];
      }, []);
    },

    toggleExpand() {
      EventBus.$emit('remote-expand');
      this.updateVisibleNodes();
    },

    updateVisibleNodes() {
      this.$nextTick(() => {
        if (this.$refs.menu) {
          const visibleNodes = Array.from(this.$refs.menu.$el.querySelectorAll('input[type="checkbox"]')).filter(el => el.offsetHeight > 0);
          this.visibleNodesIds = visibleNodes.map(node => node.value);
        }
      });
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Select/TreeSelect/TreeSelect.vue_rollup-plugin-vue=script.js